<template>
  <div>
    <div class="marginBottom20 marginTop20">添加订阅标签<span class="normalColor">（最多添加5个）</span> </div>
    <div class="marginTop20 marginBottom20">
      <span>已添加标签：</span>

      <a href="javascript:;" class="gl_pad_square_btn marginRight10 gl_pad_btn_square_active" v-for="item in addSubsribe.lablename" :key="item"> {{item}} </a>
    </div>
    <div class="border_bottom_18"></div>
    <div class="fontsize16 marginBottom20 marginTop20">
      推送频率
    </div>
    <div>
        <label for="zhou" class="marginRight40">
        <el-radio v-model="addSubsribe.frequency" label="2">每周</el-radio>
        <!-- <input type="radio" name="sel" v-model="addSubsribe.frequency"  id="zhou" value="0" />每周 -->
      </label>
      <label for="nian">
        <el-radio v-model="addSubsribe.frequency" label="1">每月</el-radio>
        <!-- <input type="radio" name="sel" v-model="addSubsribe.frequency" id="nian" value="1" />每年 -->
      </label>
      <!-- {{addSubsribe.frequency==1?'按月':'按周'}} -->
    </div>
    <!-- <div class="display_center_ud marginTop20">
      <div>
        邮箱地址：
      </div>
    </div> -->
    <div class="display_center_ud marginTop20">
      <div>
        您的邮箱地址：
      </div>
      <div>
        {{addSubsribe.pushemail}}
      </div>
    </div>
    <div class="marginTop40">
          <router-link :to="{name:'userSubscribeOpera',query:{type:'edit'}}">
 
            <a href="javascript:void(0);" class="modifybtn marginRight20"><img src="/image/geren/xiugai.png" class="marginRight5">修改订阅</a>
            </router-link>

      
      <!-- <a href="javascript:void(0);" class=" cancelbtn"><img src="/image/geren/quxiao.png" class="marginRight5">取消订阅</a> -->
       <router-link class="cancelbtn" @click.native="SaveSubscription(2)" to=""><img src="/image/geren/quxiao.png" class="marginRight5">取消订阅</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "tagSubscribeMy",
  data() {
    return {
      addSubsribe: {
        frequency: "1", //频率
        lablename: [],
        pushemail: "",
        id: 0,
        isFirstSubscript: 0,
        userid: Number(this.AuthorId), //用户ID
        username: this.userName,
        status: 0
      },
      apiData: "",
      sel: ""
    }
  },
  methods: { 
       //查询订阅信息
    GetSubscriptionInfoList() {
      let _this = this
      _this.httphelper.post('/api/SubscriptionApi/GetSubscriptionInfoList', {
        "id": 0,
        "lablename": "",
        "frequency": 0,
        "pushemail": "",
        "isFirstSubscript": 0,
        "userid": Number(this.AuthorId), //用户ID
        "username": "",
        "status": 0
      }).then(res => {
        if (res.data.code == 200) {
          if (res.data.data != null) {
            let data = res.data.data
            _this.addSubsribe = data;
            _this.addSubsribe.lablename = data.lablename.split(',');
            _this.addSubsribe.frequency = data.frequency.toString();
            _this.showLablename = _this.addSubsribe.lablename[0];
            // if (data.subscriptionInfoResult != null) {
            //   data.subscriptionInfoResult.forEach((item, index) => {
            //     if (item.typename == "资讯") {
            //       _this.newsList.push(item)
            //     }
            //     if (item.typename == "课程") {
            //       _this.courseList.push(item)
            //     }
            //     if (item.typename == "文献") {
            //       _this.articlelist.push(item)
            //     }
            //   })
            // }
            // //推送记录
            // if (data.subscriptionInfoView != null) {
            //   _this.subscriptionInfoView = data.subscriptionInfoView
            // }
          }
        }
      });
    },
    //完成订阅
    SaveSubscription(status) {
      if (status == 2) {
        this.$confirm('是否取消订阅?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.SaveSub(status);
        })
      } else {
        this.SaveSub(status);
      }
    },
    SaveSub(status) {
      let _this = this 
        _this.httphelper.post('/api/SubscriptionApi/SaveSubscriptionInfo', {
          "id": _this.addSubsribe.id,
          "lablename": _this.addSubsribe.lablename.join(','),
          "frequency": parseInt(_this.addSubsribe.frequency),
          "pushemail": _this.addSubsribe.pushemail,
          "isFirstSubscript": 1,
          "userid": Number(_this.addSubsribe.userid),
          "username": _this.userName,
          "status": status
        }).then(res => {
          if (res.data.code == 200) {
            _this.$message({
              message: res.data.msg,
              center: true,
              type: 'success'
            })
            //订阅成功，跳转信息列表
            _this.$router.push({
              path: 'userSubscribe'
            });
          } else {
            _this.$message({
              message: res.data.msg,
              center: true,
              type: 'error'
            })
          }
        });
      

    },
  },
  created() {
      //获取用户信息
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id
      this.userName = JSON.parse(localStorage.getItem("ResData")).nickname;
    }
    //1.先根据用户id查询，是否第一次订阅
    this.GetSubscriptionInfoList();
    //2.如果第一次订阅，则提交订阅信息
    //3.否则，直接显示订阅列表 
  },
}
</script>

<style scoped>
.fileBlock {
  width: 108px;
  height: 108px;
  background: #def3f3;
  border: 1px solid #0b8586;
  cursor: pointer;
}
.input {
  width: 455px;
  height: 35px;
  box-sizing: border-box;
}
.modifybtn {
  display: inline-block;
  width: 150px;
  height: 40px;
  background: #eff1f4;
  border-radius: 19px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 40px;
  text-align: center;
}
.cancelbtn {
  display: inline-block;
  width: 150px;
  height: 40px;
  background: #0b8586;
  border-radius: 19px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  line-height: 40px;
  text-align: center;
}
</style>
